import React, { Component } from 'react';
import { toast } from 'react-toastify';

import CustomModal from "../../../components/Modal/CustomModal";

import { RetirarEst } from "../../../funciones/CobranzasFunction";

class EstudiantesDisp extends Component {
    state = {
        boton:{
            icon: "fa fa-sign-out",
            title: "Retirar este estudiante"
        },
        modalBtn1: {
            icon:"fa fa-sign-out",
            text: "Retirar",
            disabled: false
        },
        openModal: false,
    }

    modalRetiro = () => {
        let { openModal, modalBtn1 } = this.state;
        let { datos } = this.props;

        let retirar = () => {
            if (modalBtn1.disabled === true) return null
 
            this.setState({
                modalBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text:"Espera",
                    disabled: true
                }
            }, () => {
                RetirarEst (datos.id, (resp) => {
                    this.setState({
                        modalBtn1: {
                            icon:"fa fa-sign-out",
                            text: "Retirar",
                            disabled: false
                        },
                        openModal: false
                    }, () => {
                        toast.info("Haz retirado al estudiante correctamente.",{autoClose: 4000})
                        this.props.funcionRefresh()
                    })
                })
            });
        }

        let contenidoModal = () => (
            <div>
                Esta opción <strong>ELIMINARÁ</strong> a <strong className="text-danger">{datos.estudiante}</strong> de la sección y no podrás relizarle el cobro de cuotas. Sin embargo su deuda quedará almacenada.
                <div><strong>¿Que deseas hacer?</strong></div>
                <div style={{fontSize: 11}} className="custom-mt-10"><strong>Nota:</strong> El estudiante no quedará eliminado de la base de datos sino solo de la sección. Esta opción no puede deshacerse</div>
            </div>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1.icon}></i> {modalBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openModal}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Confirmación</div>}
                contenido = {contenidoModal()}      
                funcion1 = {retirar}
                funcion2 = {() => {this.setState({openModal: false})}}
            />
        )
    }

    render() {
        let { datos, resaltar } = this.props;
        let { boton } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let estilo = () => {
            let est = {}

            if (resaltar === true && datos.status === "SN") est = {
                color: "#fff",
                backgroundColor: '#bf4747',
            }

            return est
        }

        let estiloBtn = () => {
            let est = { borderWidth: 1 }

            if (resaltar === true && datos.status === "SN") est = {
                color: "#fff",
                backgroundColor: '#bf4747',
                borderWidth: 1,
                borderColor: "#fff",
            }

            return est
        }

        return (
            <React.Fragment>
                <tr style={estilo()}>
                    <td style={styles}>{datos.estudiante}</td>
                    <td align="center" style={styles}>
                        <button className="btn btn-danger" onClick={() => {this.setState({openModal: true})}} style={estiloBtn()} title={boton.title}><i className={boton.icon}></i></button>
                    </td>
                </tr>
                {this.modalRetiro()}
            </React.Fragment>
        );
    }
}
 
export default EstudiantesDisp;


// WEBPACK FOOTER //
// ./src/views/Administracion/CobranzasContent/EstudiantesDisp.jsx